module.exports = __webpack_public_path__ + "static/Formation-e931fb51a4977a11a089c796bdcdf7f1.png";